import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import {
  Button,
  Grid,
  InputLabel,
  Tabs,
  Tab,
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import styles from "./inspectionDetal.module.css";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import FormDialog from "../common/FormDialog";
import { isSuperAdmin } from "../../util/form/form";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import { ESSSubQeustionList, ImageData } from "../../redux/inspection/state";
import {
  axiosPostWithFormData,
  axiosPostWithJson,
  axiosPutWithJson,
} from "../../util/axios";
import {
  OpenSnackBarWithResultFail,
  OpenSnackBarWithResultSuccess,
} from "../../redux/common/snackBar/thunk";
import { DateTimePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { ChangeInspectionQuestionParentIdAction } from "../../redux/inspection/action";
import InspectionPhoto from "./InspectionPhoto";
import RepairPhoto from "../Repair/RepairPhoto";

interface Props {
  handleCloseDialog: () => void;
}

function InspectionDetail(props: Props) {
  const dispatch = useDispatch<IRootThunkDispatch>();

  const {
    selectedInspectionItem,
    questionList,
    selected_inspection_id,
    selected_parent_question_id,
    selected_sub_question_List,
  } = useSelector((state: IRootState) => state.inspectionState);
  const { user } = useSelector((state: IRootState) => state.userAuth);
  const isSuperAdminRole = isSuperAdmin(user?.token?.role_id as number);
  const [rotation, setRotation] = useState<number[]>([]);
  const [clickPhoto, setClickPhoto] = useState<number | null>(null);
  const [ImageDialogOpen, setImageDialogOpen] = useState<boolean>(false);
  const [photoTime, setPhotoTime] = useState<number | null>(null);
  const [tabValue, setTabValue] = useState<number>(0);

  useEffect(() => {
    const selectedParentQuestionId = questionList[0].parent_question_id;

    dispatch(ChangeInspectionQuestionParentIdAction(selectedParentQuestionId));
  }, []);

  const handleImageClick = (index: number) => {
    setRotation((prevRotation) => {
      const newRotation = [...prevRotation];
      newRotation[index] = (newRotation[index] || 0) + 90;
      return newRotation;
    });
  };

  function handleMouseUp(index: number) {
    setImageDialogOpen(true);
    setClickPhoto(index);
  }

  function handleImageDialogClose() {
    setClickPhoto(null);
    setImageDialogOpen(false);
  }

  async function handleChangeCleaningPhoto(
    event: ChangeEvent<HTMLInputElement>,
    sub_question: ESSSubQeustionList | ImageData,
    isFurtherAction: boolean = false,
  ) {
    const files = event.target.files;
    if (!files) return;
    const form = new FormData();
    const file = files[0];

    const subQuestionId =
      "sub_question_id" in sub_question
        ? sub_question.sub_question_id
        : sub_question.answer_id;
    form.append(subQuestionId.toString(), file);

    if (!photoTime) {
      dispatch(OpenSnackBarWithResultFail("你未有挑選時間"));
      dispatch(OpenLoadingBarThunk(false));
      return;
    }
    form.append("parent_question_id", sub_question.parent_question_id!.toString());
    form.append("timestamp", photoTime!.toString());
    form.append("source", "cms");
    if (isFurtherAction) {
      form.append("is_further_action", "1");
    }
 
    dispatch(OpenLoadingBarThunk(true));

    const res = await axiosPostWithFormData(
      "api/inspection/Photo/" + selected_inspection_id,
      form,
    );
    if (res.data.success) {
      dispatch(OpenSnackBarWithResultSuccess("你已成功增加相片"));
      props.handleCloseDialog();
    }
    dispatch(OpenLoadingBarThunk(false));
    setPhotoTime(null);
  }

  async function handleDeleteImage(inspection: ImageData) {
    const data = {
      inspection_id: selected_inspection_id,
      inspection_image_id: inspection.inspection_image_id,
      inspection_response_id: inspection.inspection_response_id,
    };



    const res = await axiosPutWithJson("api/inspection/Photo/", data);

    if (res.data.success) {
      dispatch(OpenSnackBarWithResultSuccess("你已成功刪除相片"));
      props.handleCloseDialog();
    }
    dispatch(OpenLoadingBarThunk(false));
  }

  function handlePhotoTimeChange(date: moment.Moment | null) {
    const unix = moment(date).local().valueOf();
    setPhotoTime(unix);
  }

  function handleChangeParentQuestionId(event: SelectChangeEvent) {
    const selectedParentQuestionId = parseInt(event.target.value);

    dispatch(ChangeInspectionQuestionParentIdAction(selectedParentQuestionId));
  }

  async function handleClickReview(review_date: number) {
    const data = {
      inspection_id: selected_inspection_id,
      review_date: review_date,
    };
    const res = await axiosPostWithJson(`api/inspection/review`, data);
    if (res.data.success) {
      dispatch(OpenSnackBarWithResultSuccess("你已成功審核維修"));
      props.handleCloseDialog();
    }
  }

  function handleChangeTab(value: number) {
    console.log("handleChangeTab", value);
    setTabValue(value);
  }


  function generateBigPhoto(){
    console.log('clickPhoto',clickPhoto)
    const index = selectedInspectionItem?.imageArray.findIndex((item) => item.inspection_response_id === clickPhoto)
    if (index == -1 || index == undefined) return (<>No Data</>)


    return (
             <Grid>
              <Grid className={styles.bigImageContainer}>
                <img
                  src={
                    ImageDialogOpen && index != undefined 
                      ? `${process.env.REACT_APP_S3}${
                          selectedInspectionItem!.imageArray[index]
                            .image_thumb
                        }`
                      : ""
                  }
                  className={styles.bigImageContainer}
                ></img>
              </Grid>
            </Grid>
    )
  }


 
  return (
    <>
      <Grid>
        <Grid>
          <Grid
            className={styles.inspectionPhotoOuterContainer}
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              flexWrap: "wrap",
              width: "100%",
              alignItems: "flex-start",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={tabValue}
                onChange={(_, newValue) => handleChangeTab(newValue)}
              >
                <Tab label="檢查時" value={0} />
                <Tab label="進一步處理" value={1} />
              </Tabs>

              <Grid style={{ marginBottom: 20 }}>
                <InputLabel htmlFor="enquiry-date-picker">相片日期</InputLabel>
                <DateTimePicker
                  onChange={(data) =>
                    handlePhotoTimeChange(data as moment.Moment)
                  }
                  value={moment.utc(photoTime)}
                  sx={{ width: "100%" }}
                  format="YYYY-MM-DD HH:mm"
                  timeSteps={{ minutes: 1 }}
                  ampm={false}
                />
              </Grid>

              {tabValue === 0 && (
                <InspectionPhoto
                  handleChangeParentQuestionId={handleChangeParentQuestionId}
                  handleChangeCleaningPhoto={handleChangeCleaningPhoto}
                  handleMouseUp={handleMouseUp}
                  rotation={rotation}
                  handleImageClick={handleImageClick}
                  handleDeleteImage={handleDeleteImage}
                />
              )}

              {tabValue === 1 && (
                <RepairPhoto
                  handleMouseUp={handleMouseUp}
                  rotation={rotation}
                  handleImageClick={handleImageClick}
                  handleDeleteImage={handleDeleteImage}
                  handleChangeCleaningPhoto={handleChangeCleaningPhoto}
                  handleClickReview={handleClickReview}
                />
              )}
            </Box>
          </Grid>
        </Grid>

        {ImageDialogOpen ? (
          <FormDialog
            title="相片"
            open={ImageDialogOpen}
            handleClose={handleImageDialogClose}
            size={"lg"}
          >
            {generateBigPhoto()}
          </FormDialog>
        ) : (
          <></>
        )}
      </Grid>
    </>
  );
}

export default InspectionDetail;
